import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import TextArea from "components/basic/textArea";
import Typography from "components/basic/typography";
import { ReviseQuoteDraft } from "../../types";

export interface VendorNoteSectionProps {
  draft: ReviseQuoteDraft;
  onChange: (patch: Partial<ReviseQuoteDraft>) => void;
}

/** Why the quote changed — reaches the customer by email and in the thread. */
const VendorNoteSection: React.FC<VendorNoteSectionProps> = ({
  draft,
  onChange,
}) => {
  const theme = useTheme();
  const { t } = useTranslation("leads");

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
      }}
    >
      <Typography variant="subtitle2">{t("revise.vendor_note")}</Typography>
      <TextArea
        minRows={3}
        maxRows={6}
        value={draft.vendorNote}
        placeHolder={t("revise.vendor_note_placeholder")}
        ariaLabel={t("revise.vendor_note_label")}
        onChange={(e) => onChange({ vendorNote: e.target.value })}
      />
    </div>
  );
};

export default VendorNoteSection;
